export const DEFAULT_ZONE_ID = 1;
export const ALL_ZONES_ID = -1;


// WEBPACK FOOTER //
// ./src/constants/zones.js